/* eslint-disable react/prop-types */
import React from "react";

import { Modal, ModalContent, ModalBody } from "@nextui-org/modal";
import AdjustAmountForm from "./AdjustAmountForm";
import {
  stringToTicketPhase,
  TicketPhase,
} from "../assets/js/AppTicketConstant";

const RejectDescriptionModal = ({
  isOpen,
  onOpenChange,
  rejectReason,
  subTicketData,
  ticketPhase,
}) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        placement="center"
        onOpenChange={onOpenChange}
        size="5xl"
        closeButton={
          <svg
            width="34"
            height="34"
            viewBox="0 0 24 24"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: "absolute",
              right: "26px",
              top: "35px",
              background: "transparent",
            }}
          >
            <path
              d="M6 18L18 6M6 6L18 18"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
      >
        <ModalContent>
          {() => (
            <>
              <ModalBody className="flex flex-col justify-center my-5 mx-5 bg-[#FF0000] bg-opacity-15 rounded-lg p-6">
                <p className="font-bold text-lg mb-4">
                  เหตุผลการปฏิเสธการอนุมัติ
                </p>
                <AdjustAmountForm
                  proposalAmount={
                    stringToTicketPhase(ticketPhase) === TicketPhase.Proposal
                      ? subTicketData.proposal_amount
                      : subTicketData.claim_amount
                  }
                  adjustAmount={rejectReason?.adjusted_amount}
                />
                <p className="text-pretty break-words whitespace-pre-wrap overflow-y-auto max-h-48 pl-8">
                  {rejectReason?.description}
                </p>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default RejectDescriptionModal;
